var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.modules && !!_vm.modules['services'])?_c('router-link',{staticClass:"btn btn-link",attrs:{"to":"/app/bookings/serviceorders"}},[_c('fa-icon',{attrs:{"icon":"file-signature"}}),_vm._v(" Service Orders ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }